import { createContext, useContext } from 'react';
import type { Lang } from './routes';
import { pathFor, type PageKey } from './routes';

const LanguageContext = createContext<Lang>('nl');

export function LanguageProvider({ lang, children }: { lang: Lang; children: React.ReactNode }) {
  return <LanguageContext.Provider value={lang}>{children}</LanguageContext.Provider>;
}

export function useLang(): Lang {
  return useContext(LanguageContext);
}

/** Pick the active language out of a `{ nl, en }` dictionary. */
export function useT<D extends Record<Lang, unknown>>(dict: D): D['nl'] | D['en'] {
  return dict[useLang()];
}

/** Build a link to another page, staying in the active language. */
export function useLocalPath() {
  const lang = useLang();
  return (key: PageKey, rest?: string) => pathFor(key, lang, rest);
}
